var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentTags({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_2243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_2243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19C3.44772 19 3 18.5523 3 18V14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V18C11 18.5523 10.5523 19 10 19H4ZM14 19C13.4477 19 13 18.5523 13 18V14C13 13.4477 13.4477 13 14 13H20C20.5523 13 21 13.4477 21 14V18C21 18.5523 20.5523 19 20 19H14ZM4 11C3.44772 11 3 10.5523 3 10V6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V10C21 10.5523 20.5523 11 20 11H4ZM5 17H9V15H5V17ZM15 17H19V15H15V17Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentTags);
export default __webpack_public_path__ + "static/media/content_tags.dd385115597c7735b3bfdee4f76740fb.svg";
export { ForwardRef as ReactComponent };